module.exports = __webpack_public_path__ + "static/media/head_image.7c7c0487.png";